import useGetPassengersName
    from "@CheckOrder/features/classPicker/features/additionalPassengerClassSelectModal/hooks/useGetPassengersName";

interface PassengerClassSelectModalHeaderProps {
    passengerId: number,
}

function PassengerClassSelectModalHeader({passengerId}: PassengerClassSelectModalHeaderProps) {
    const {getPassengerName} = useGetPassengersName()

    return (
        <>
            <p className="title">
                Where would you like to add
                &nbsp;
                <span>
                    {getPassengerName(passengerId)}
                </span>
                ?
            </p>
            <p className="price-change">
                Price per person
            </p>
        </>
    )
}

export default PassengerClassSelectModalHeader